import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {MailEditorComponent} from "./mail-editor/mail-editor.component";
import {ListMailComponent} from "./list-mail/list-mail.component";

const routes: Routes = [
  {
    path: 'list',
    component: ListMailComponent
  },
  {
    path: "type/:mailAdminId", component: MailEditorComponent
  }
  ,
  {
    path: "type/new", component: MailEditorComponent
  },
  {
    path: "type/:mailTypeAdminId/edit/:mailAdminId", component: MailEditorComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ManageMailRoutingModule {
}
